export default __webpack_public_path__ + "static/media/gallery - potions_04.3f4d4c15.jpg";